/** Canonical AutoGo brand assets (keep in sync with backend/server.py contract + email logos). */
export const BRAND_ICON_SRC = '/brand/autogo-icon.png';
export const BRAND_LOGO_SRC = '/brand/autogo-contract-logo.png';
